'use strict';

import $ from 'jquery';
import uniform from '../../components/uniform';
import config from '../../config/config';

const mobileMQ = window.matchMedia(`(max-width: ${config.BREAKPOINTS.TABLET_MAX}px)`);
let $container = $('#orderhistory');
let pageSizes = {};
let ordersCache = {};
let initialLoad = true;
let moreOrdersRequested = false;

if ($container.length) {
    pageSizes = $container.data('page-sizes');
}

const initOrderEvents = () => {
    $('#primary').on('click', 'a.show-more-orders', function (e) {
        if (moreOrdersRequested) {
            return;
        }
        moreOrdersRequested = true;
        e.preventDefault();
        loadAllOrders(mobileMQ, this.href);
    });
};

const loadOrders = mobileMQ => {
    const sz = mobileMQ.matches ? pageSizes.mobile : pageSizes.desktop;
    const $hitCount = $container.find('.results-hits');
    if (sz in ordersCache) {
        $container.html('');
        $container.append(ordersCache[sz]);
    } else if (
        initialLoad ||
        ($container.find('.no-orders').length === 0 && $('.order-list-item').length < $hitCount.data('count'))
    ) {
        initialLoad = false;
        $container.html('');
        $container.addClass('additional-loading');
        $.ajax({
            url: $container.data('get-orders'),
            type: 'GET',
            dataType: 'html',
            data: {
                sz
            },
            success: response => {
                ordersCache[sz] = response;
                $container.append(response);
                initOrderEvents();
                $container.removeClass('additional-loading');
            },
            error: err => {
                $container.removeClass('additional-loading');
            }
        });
    }
};

const loadAllOrders = (mobileMQ, href) => {
    const start = mobileMQ.matches ? pageSizes.mobile : pageSizes.desktop;
    let loadingPlaceHolder = $('.show-more-placeholder[data-loading-state="unloaded"]');
    loadingPlaceHolder.attr('loading-state', 'loading');
    loadingPlaceHolder.addClass('additional-loading');
    $('.show-more-ctr').hide();
    $.ajax({
        url: href,
        type: 'GET',
        dataType: 'html',
        data: {
            start
        },
        success: response => {
            let $orderList = $container.find('.order-list');
            $orderList.append(response);
            uniform();
            loadingPlaceHolder.removeClass('additional-loading');
            loadingPlaceHolder.attr('data-loading-state', 'loaded');
            mobileMQ.removeEventListener('change', loadOrders);
        },
        error: err => {
            loadingPlaceHolder.removeClass('additional-loading');
            loadingPlaceHolder.attr('data-loading-state', 'unloaded');
            $('.show-more-ctr').show();
        }
    });
};

export const init = () => {
    loadOrders(mobileMQ);
    mobileMQ.addEventListener('change', loadOrders);
    initOrderEvents();
};
